<template>
  <div>
    <v-row no-gutters class="ma-0">
      <v-col cols="12">
        <v-card elevation="0" class="pa-4 list-box-Shadow">
          <v-row no-gutters>
            <v-col cols="6" class="d-flex align-center justify-start">
              <PrimaryButton
                class="btn-box mr-4"
                @click="$router.back()"
                icon="mdi-arrow-left-bold"
                iconSize="large"
                iconClass="ma-0"
                v-show="isBackBtnVisible"
              >
              </PrimaryButton>
              <h4 class="font-weight-bold text_color--text">
                {{ title }}
              </h4>
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              <slot name="action"></slot>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        class="overflow-y-auto overflow-x-hidden app-relative"
        :style="contentStyle"
      >
        <slot name="detail" />
      </v-col>
      <v-col class="d-none">
        <slot name="dialog" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: true,
    },
    contentStyle: {
      default: "height: calc(100vh - 130px)",
    },
    isBackBtnVisible: {
      default: true,
    },
    detailClass: {
      type: String,
      default: "background_color",
    },
  },
};
</script>
<style scoped lang="scss">
.auto-height {
  height: calc(100vh - 180px);
  position: relative;
}
</style>
